import { render, staticRenderFns } from "./OfferingItem.vue?vue&type=template&id=b035ca98&scoped=true"
import script from "./OfferingItem.vue?vue&type=script&lang=js"
export * from "./OfferingItem.vue?vue&type=script&lang=js"
import style0 from "./OfferingItem.vue?vue&type=style&index=0&id=b035ca98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b035ca98",
  null
  
)

export default component.exports